import React from 'react';
import hsbMembers from '../../cms/hsb.json';
import pageIntros from '../../cms/page-intros.json';
import MemberGridPage from '../../components/pages/MemberGridPage';

const intro = pageIntros.hsb || {};

const HSB = () => {
  return (
    <MemberGridPage
      members={hsbMembers}
      title={intro.title}
      subtitle={intro.subtitle}
      introText={intro.intro}
      baseRoute="/student-board"
      paramName="hsbId"
    />
  );
};

export default HSB;

